// Copyright (c) 2016 Deere & Company

import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import t from 'tcomb';

const DealerAccountsFacet = t.struct({
    allowedDealers: t.list(Dealer),
    displayedDealers: t.list(Dealer),
    isInitialLoad: t.Boolean,
    searchInput: t.String,
    selectedDealers: t.list(Dealer)
}, 'DealerAccountsFacet');

export const getDefaultState = () =>
    new DealerAccountsFacet({
        allowedDealers: [],
        displayedDealers: [],
        isInitialLoad: true,
        searchInput: '',
        selectedDealers: []
    });

export default DealerAccountsFacet;



// WEBPACK FOOTER //
// ./src/shared/state/dealer-accounts-facet.js